import React from 'react';
import toWebpImage from '@src/utils/to-webp-image';
import wrapStore from '@src/utils/wrap-store';
import HighlightScreenStore from './store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import cx from 'classnames';

const styles = require('./index.less');

const HighlightScreen = ({ store }) => {
  store.use();
  return (
    <div className={cx(styles.highlightScreenRoot, store.isActive && styles.highlightScreenRootAct)}>
      {/* 轮播根容器 */}
      <div className={styles.swiperRoot}>
        <div className={styles.swiperRootContent}>
          <div className={styles.swiperBg} />
          {/* 实际显示内容的轮播层 */}
          <div className={styles.swiperContent}>
            <BaseSwiper store={store.seasonSwiperStore}>
              {store.swiperData.map((item, index) => (
                <div key={index} className={styles.swiperItem}>
                  <img alt="" src={item.swiperImg} />
                </div>
              ))}
            </BaseSwiper>
          </div>
          {/* 实际触发滑动轮播的轮播层 */}
          {/* <div className={styles.swiperControl}>
            <BaseSwiper store={store.swiperControlStore}>{store.swiperData.map((item, index) => <div key={index} className={styles.swiperItem} />)}</BaseSwiper>
          </div> */}

          {/* 内容控制层 */}
          <div className={styles.contentInfo}>
            <div className={styles.swiperDecorate} />
            <img alt="" className={styles.swiperCurrentIndex} src={toWebpImage(require(`./images/season-code-0${store.swiperActionIndex + 1}.png`))} />
            <div className={styles.desc}>
              <div className={cx(styles.descItem, styles.descItem1)}>{store.swiperData[store.swiperActionIndex].desc}</div>
              <div className={cx(styles.descItem, styles.descItem2)}>{store.swiperData[store.swiperActionIndex].desc2}</div>
            </div>
            <div className={styles.moduleTitle} />
          </div>
        </div>
      </div>
      {/* 轮播切换锚点层 */}
      <div className={styles.swiperAnchors}>
        {store.swiperData.map((item, index) => (
          <div
            key={index}
            className={cx(styles.swiperItem, store.swiperActionIndex === index && styles.swiperItemActive)}
            onClick={() => (store.swiperActionIndex = index)}
          >
            <div className={styles.swiperItemImg}>
              <img alt="" src={item.swiperImg} />
              <div className={styles.swiperItemTitle}>{item.title}</div>
            </div>
            <div className={styles.hoverDecorate1} />
            <div className={styles.hoverDecorate2} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default wrapStore(HighlightScreen, HighlightScreenStore);
